interface WorldWithCircuitsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorldWithCircuitsSVG = ({ color, style }: WorldWithCircuitsSVGProps) => (
  <svg
    style={style}
    width="50"
    height="52"
    viewBox="0 0 50 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.4408 8.54069C37.4408 9.50194 38.1722 10.2781 39.0767 10.2781C39.9812 10.2781 40.7126 9.49896 40.7126 8.54069C40.7126 7.58243 39.9812 6.80328 39.0767 6.80328C38.1722 6.80328 37.4408 7.58243 37.4408 8.54069Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.2557 8.57947H31.4345V12.2752H24.7565"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.1395 14.3559C41.1395 15.3709 41.9037 16.1919 42.8471 16.1919C43.7904 16.1919 44.5546 15.3709 44.5546 14.3559C44.5546 13.341 43.7904 12.52 42.8471 12.52C41.9037 12.52 41.1395 13.341 41.1395 14.3559Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.0499 14.3948H33.9839V18.0905H24.7565"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.056 20.9831C43.056 22.0489 43.868 22.9146 44.8711 22.9146C45.8741 22.9146 46.6861 22.0489 46.6861 20.9831C46.6861 19.9174 45.8741 19.0517 44.8711 19.0517C43.868 19.0517 43.056 19.9174 43.056 20.9831Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.053 21.0219H37.2318V23.8788H25.1088"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.1777 4.224L25.058 4.23594"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2615 4.10459C33.2615 5.0121 32.5689 5.74647 31.7181 5.74647C30.8673 5.74647 30.1747 5.0121 30.1747 4.10459C30.1747 3.19708 30.8673 2.46271 31.7181 2.46271C32.5689 2.46271 33.2615 3.19708 33.2615 4.10459Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.4408 44.065C37.4408 43.1038 38.1722 42.3276 39.0767 42.3276C39.9812 42.3276 40.7126 43.1068 40.7126 44.065C40.7126 45.0233 39.9812 45.8025 39.0767 45.8025C38.1722 45.8025 37.4408 45.0233 37.4408 44.065Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.2557 44.0262H31.4345V40.3305H24.7565"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.8501 40.0857C43.7931 40.0857 44.5576 39.2638 44.5576 38.2498C44.5576 37.2359 43.7931 36.4139 42.8501 36.4139C41.907 36.4139 41.1425 37.2359 41.1425 38.2498C41.1425 39.2638 41.907 40.0857 42.8501 40.0857Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.0499 38.211H33.9839V34.5153H24.7565"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.056 31.6226C43.056 30.5569 43.868 29.6912 44.8711 29.6912C45.8741 29.6912 46.6861 30.5569 46.6861 31.6226C46.6861 32.6883 45.8741 33.5541 44.8711 33.5541C43.868 33.5541 43.056 32.6883 43.056 31.6226Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.053 31.5838H37.2318V28.7269H25.1088"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.1777 48.3817L25.058 48.3698"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2615 48.5011C33.2615 47.5936 32.5689 46.8593 31.7181 46.8593C30.8673 46.8593 30.1747 47.5936 30.1747 48.5011C30.1747 49.4086 30.8673 50.143 31.7181 50.143C32.5689 50.143 33.2615 49.4086 33.2615 48.5011Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.7565 3.63594V48.731C24.7565 49.3818 24.246 49.9102 23.6311 49.8773C11.8185 49.2534 2.42093 38.8678 2.42093 26.1476C2.42093 13.4275 11.7826 3.08069 23.5654 2.42394C24.2132 2.38811 24.7535 2.94635 24.7535 3.63594H24.7565Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5743 2.50153C22.5743 2.50153 -1.20612 24.9267 22.7355 49.743"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.42093 26.1476H24.7535"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.43909 39.7454C12.726 37.0199 18.6278 35.7512 24.7535 35.7512"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.21222 13.3857C12.4991 16.1112 18.6278 17.4755 24.7535 17.4755"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WorldWithCircuitsSVG;
